import styled from 'styled-components';

export const MainPageBlock = styled.div`
  display: grid;
  gap: 24px;

  &.grid1 {
    grid-template-columns: 1fr;
  }

  &.grid2 {
    grid-template-columns: repeat(2, minmax(300px, calc((100% - 24px) / 2)));
    @media (max-width: 900px) {
      grid-template-columns: 1fr;
    }
  }
  &.grid3 {
    grid-template-columns: repeat(3, minmax(250px, calc((100% - 24px) / 3)));
    @media (max-width: 900px) {
      grid-template-columns: 1fr;
    }
  }
  // When only one child renders, span the full row so it never looks half-cut
  &.grid2 > *:only-child,
  &.grid3 > *:only-child {
    grid-column: 1 / -1;
  }
  &.noStretchSingle.grid2 > *:only-child,
  &.noStretchSingle.grid3 > *:only-child {
    grid-column: auto;
  }
  &.equalCards > * {
    height: 100%;
  }
  align-items: stretch;
  @media (max-width: 900px) {
    grid-template-columns: 1fr;
  }
  &.mTop20 {
    margin-top: 20px;
  }
  &.compact {
    max-width: 720px;
  }
  &.mTop16 {
    margin-top: 16px;
  }
  &.mTop40 {
    margin-top: 40px;
  }
  &.Graphs {
    overflow-x: auto;
  }
`;

export const MainPageContainer = styled.div`
  padding: 20px 20px 20px 22px;
  background-color: #ffffff;
  border-radius: 10px;
  position: relative;
  box-shadow: 0 8px 16px 0 #dddddd52;
  .AttentionAction {
    width: 216px;
    flex-shrink: 0;
    @media (max-width: 600px) {
      width: 100%;
      margin-top: 16px;
    }
  }
  &.flex {
    display: flex;
  }
  &.oneLine {
    display: flex;
    align-items: center;
    @media (max-width: 600px) {
      flex-direction: column;
      align-items: stretch;
    }
  }
  &.spaceBetween {
    display: flex;
    justify-content: space-between;
  }
  &.withImg {
    padding: 20px 0 0 22px;
  }
  &.growthCardStacked {
    display: flex;
    flex-direction: column;
    padding: 20px 0 0 22px;
  }
  .SauceChartLabel {
    font-size: 12px;
    color: #b3b9c2;
  }

  &:first-child {
    .DropInfoUpInsightsPerformance {
      @media (max-width: 1250px) {
        right: inherit;
        left: -36px;

        &::after {
          right: inherit;
          left: 14px;
        }
      }
      @media (max-width: 900px) {
        right: -18px;
        left: initial;

        &::after {
          right: 29px;
          left: initial;
        }
      }
    }
  }
  &:nth-child(4n + 5) {
    .DropInfoUpInsightsPerformance {
      @media (max-width: 1250px) {
        right: inherit;
        left: -36px;

        &::after {
          right: inherit;
          left: 14px;
        }
      }
      @media (max-width: 1085px) {
        right: -18px;
        left: initial;

        &::after {
          right: 29px;
          left: initial;
        }
      }
    }
  }
  &:nth-child(3n + 4) {
    .DropInfoUpInsightsPerformance {
      @media (max-width: 1085px) {
        right: inherit;
        left: -36px;

        &::after {
          right: inherit;
          left: 14px;
        }
      }
      @media (max-width: 900px) {
        right: -18px;
        left: initial;

        &::after {
          right: 29px;
          left: initial;
        }
      }
    }
  }
  &:nth-child(odd) {
    .DropInfoUpInsightsPerformance {
      @media (max-width: 900px) {
        right: -18px;
        left: initial;

        &::after {
          right: 29px;
          left: initial;
        }
      }
    }
  }
`;

export const MainPageGrowthCardHeader = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px 13px;
  padding-right: 20px;
`;

export const MainPageGrowthCardBody = styled.div`
  display: flex;
  flex: 1;
`;

export const MainPageGrowthCardLabel = styled.span`
  border-radius: 25px;
  padding: 2px 8px;
  color: #ffffff;
  background-color: #17c981;
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  box-shadow: 0 5px 10px 0 #00000033;
  white-space: nowrap;
  flex-shrink: 0;
`;

export const MainPageContainerLeftBlock = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  &.withImg {
    // width: 60%;
    flex: 1 1 auto;
    margin-right: 100px;
    @media (max-width: 1400px) {
      margin-right: 48px;
    }
    @media (max-width: 550px) {
      margin-right: 40px;
    }
  }
  .mTop20 {
    margin-top: 20px;
  }
  .mB20 {
    margin-bottom: 20px;
  }
  &.smallContainer {
    margin-right: 0;
  }
`;

export const MainPageContainerRightBlock = styled.div`
  &.withImg {
    max-width: 130px;
    min-width: 100px;
    width: 22.5%;
    display: flex;
    align-items: flex-end;
    flex: 0 0 auto;
    img {
      width: 100%;
    }
    @media (min-width: 1800px) {
      min-width: 200px;
      max-width: 250px;
    }
  }
  &.bigImg {
    width: 30%;
    min-width: 200px;
    max-width: 272px;
  }
  &.smallContainer {
    width: 25%;
    min-width: 120px;
    max-width: 272px;
  }
`;

export const MainPageContainerTitleBlock = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  .bold {
    font-weight: 700;
  }
  .grey {
    color: #b3b9c2;
  }
`;

export const MainPageContainerTitle = styled.div`
  font-weight: 700;
  font-size: 16px;

  @media (min-width: 1800px) {
    font-size: clamp(16px, 1vw, 22px);
  }

  &.withIcon {
    display: flex;
    align-items: center;
    img {
      margin-right: 16px;
    }
    .doubleLine {
      display: flex;
      flex-direction: column;
      span:last-child {
        font-weight: 400;
      }
    }
  }

  &.withLabel {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 8px 13px;
    @media (max-width: 600px) {
      align-items: flex-start;
    }
    .label {
      margin-left: 13px;
      border-radius: 25px;
      padding: 2px 8px;
      color: #ffffff;
      background-color: #17c981;
      font-size: 12px;
      font-weight: 700;
      text-transform: uppercase;
      box-shadow: 0 5px 10px 0 #00000033;
      white-space: nowrap;
      align-self: center;
      &.red {
        background-color: #ff2d38;
      }
      @media (max-width: 600px) {
        margin-left: 0;
        align-self: flex-start;
      }
      &.limitedTime {
        white-space: nowrap;
      }
    }
  }

  &.font14 {
    font-size: 14px;
    @media (min-width: 1800px) {
      font-size: clamp(14px, 1vw, 20px);
    }
  }

  .high {
    color: #17c981;
  }
  &.mBottom13 {
    margin-bottom: 13px;
  }
`;

export const MainPageContainerText = styled.div`
  &.font42 {
    font-weight: 100;
    font-size: 42px;
    @media (min-width: 1800px) {
      font-size: clamp(42px, 1vw, 48px);
    }
  }
  &.mTop11 {
    margin-top: 11px;
  }
  &.mTop15 {
    margin-top: 15px;
  }
  &.mTop6 {
    margin-top: 6px;
  }
  &.mTop8 {
    margin-top: 8px;
  }
  &.font12 {
    font-size: 12px;
    @media (min-width: 1800px) {
      font-size: clamp(12px, 1vw, 18px);
    }
  }
  &.fontBold {
    font-weight: bold;
  }
  &.alignCenter {
    display: flex;
    align-items: center;
  }
  &.justifySpaceBetween {
    display: flex;
    justify-content: space-between;
  }
  .percentChange {
    margin-left: 15px;
    font-size: 16px;
    color: #b3b9c2;
    &.positive {
      font-weight: 500;
      color: #17c981;
    }
    @media (min-width: 1800px) {
      font-size: clamp(16px, 1vw, 22px);
    }
  }
  .grey {
    font-size: 16px;
    font-weight: 500;
    color: #b3b9c2;
    @media (min-width: 1800px) {
      font-size: clamp(16px, 1vw, 22px);
    }
  }
  &.colorGray {
    color: #b3b9c2;
  }
  .bold {
    font-weight: 700;
  }
  &.progressBar {
    width: 40%;
  }
  .red {
    color: #ff2d38;
  }
  &.withImg {
    // max-width: 300px;

    @media (min-width: 1800px) {
      // max-width: 400px;
    }
  }
  &.withButton {
    max-width: 700px;
  }
  &.noOrders {
    font-size: 16px;
    color: #b3b9c2;
    margin-top: 35px;
    @media (min-width: 1800px) {
      font-size: clamp(16px, 1vw, 22px);
    }
  }
  svg {
    margin-left: 10px;
    transform: rotate(180deg);
    path {
      fill: #17c981;
    }
  }
`;

export const MainPageContainerSubText = styled.div`
  font-size: 12px;
  margin-top: 8px;
  color: #b3b9c2;
  display: flex;
  align-items: center;
  svg {
    width: 12px;
    margin-right: 6px;
  }
`;

export const MainPageContainerTextBlock = styled.div`
  display: flex;
  justify-content: space-between;
  &.mTop8 {
    margin-top: 8px;
  }
  &.columns {
    justify-content: flex-start;
    .block {
      width: 50%;
    }
  }
  &.alignCenter {
    align-items: center;
  }
`;

export const MainPageCardButton = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin: 50px 0 15px 0;
  span {
    font-size: 14px;
    font-weight: 700;
    color: #ff2d38;
    cursor: pointer;
    @media (min-width: 1800px) {
      font-size: clamp(14px, 1vw, 20px);
    }
  }
  &.buttonsGroup {
    span:first-child {
      margin-right: 40px;
    }
  }
  &.mTop16 {
    margin-top: 16px;
  }
`;

export const MainPageSalesPerItemLine = styled.div`
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  padding: 8px 0;
  font-size: 12px;
  @media (min-width: 1800px) {
    font-size: clamp(12px, 1vw, 18px);
  }
  .bold {
    font-weight: 700;
  }
  .flex {
    display: flex;
  }
  .marginRight3 {
    margin-right: 3px;
  }
  .marginRight6 {
    margin-right: 6px;
  }
`;

export const ReferFriendCard = styled.div`
  display: flex;
  align-items: center;
  gap: 32px;
  background-color: #e3fff4;
  border-radius: 16px;
  padding-right: 28px;
  padding-top: 12px;
  @media (max-width: 900px) {
    flex-direction: column;
    align-items: stretch;
    gap: 16px;
    padding: 20px;
    text-align: center;
  }
`;

export const ReferFriendImage = styled.div`
  flex: 0 0 auto;
  display: block;
  img {
    display: block;
  }
  @media (max-width: 900px) {
    align-self: center;
    img {
      width: 160px;
      height: auto;
    }
  }
`;

export const ReferFriendBody = styled.div`
  flex: 1 1 auto;
  min-width: 0;
  .title {
    font-size: 18px;
    font-weight: 700;
    color: #2f3d48;
    margin-bottom: 6px;
  }
  .text {
    font-size: 14px;
    color: #2f3d48;
    line-height: 1.45;
    .red {
      color: #ff2d38;
    }
  }
`;

export const ReferFriendAction = styled.div`
  flex: 0 0 auto;
`;

export const DailySnapshotHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
  margin-top: 35px;
  margin-bottom: 14px;

  > :first-child {
    flex: 1 1 auto;
    min-width: 0;
    margin: 0;
  }
`;

export const DailySnapshotChannelSelect = styled.div`
  && {
    flex: 0 0 auto;
    width: auto;
    min-width: 180px;
  }
`;

export const ByocPromoCard = styled(ReferFriendCard)`
  background-color: #fff6e5;
  margin-top: 16px;
`;

export const ByocPromoImage = styled(ReferFriendImage)``;

export const ByocPromoBody = styled(ReferFriendBody)`
  .title {
    margin-bottom: 4px;
  }
`;

export const ByocPromoAction = styled(ReferFriendAction)``;

export const TopDishesGrid = styled.div`
  margin-top: 6px;
  display: grid;
  grid-template-columns: 1fr auto auto;
  column-gap: 48px;
  row-gap: 7px;
  align-items: center;
  @media (max-width: 600px) {
    column-gap: 20px;
  }
`;

export const TopDishesHeader = styled.div`
  font-size: 12px;
  font-weight: 700;
  color: #b3b9c2;
  text-align: left;
  &:first-of-type {
    grid-column: 2;
  }
`;

export const TopDishesName = styled.div`
  font-size: 12px;
  .bold {
    font-weight: 700;
    margin-right: 4px;
  }
`;

export const TopDishesValue = styled.div`
  font-size: 12px;
  font-weight: 700;
  text-align: right;
  white-space: nowrap;
`;

export const TopDishesDivider = styled.hr`
  grid-column: 1 / -1;
  width: 100%;
  border: 0;
  border-top: 1px solid #eef0f4;
  margin: 0;
`;

export const MainPageLine = styled.div`
  margin-top: 50px;
  hr {
    margin: 0;
  }
`;

export const SectionTitleRow = styled.div`
  display: flex;
  align-items: center;
  white-space: nowrap;
  margin-top: 35px;
  margin-bottom: 14px;
`;

export const SectionTitleText = styled.div`
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 1.2;
  color: #2f3d48;
  @media (max-width: 1250px) {
    font-size: 20px;
  }
`;

export const SectionTitleLine = styled.div`
  flex: 1 1 auto;
  height: 2px;
  margin: 0 12px;
  opacity: 0.3;
  background-color: #929cb9;
`;

export const SectionTitleCTA = styled.span`
  font-size: 14px;
  font-weight: 700;
  color: #ff2d38;
  cursor: pointer;
  flex-shrink: 0;
  &:hover {
    opacity: 0.85;
  }
`;

export const TopBadge = styled.span`
  display: inline-block;
  margin-left: 8px;
  padding: 2px 10px;
  background-color: #d4f4dd;
  color: #1a7a3a;
  font-size: 10px;
  font-weight: 700;
  border-radius: 12px;
  vertical-align: middle;
`;

export const TopCustomerCardRow = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 8px;
`;

export const TopCustomerAvatar = styled.div`
  flex: 0 0 auto;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  font-weight: 700;
  font-family: 'Poppins';
  &.purple {
    background-color: #4671db20;
    color: #4671db;
  }
  &.green {
    background-color: #17c98120;
    color: #17c981;
  }
`;

export const TopCustomerCardBody = styled.div`
  flex: 1 1 auto;
  min-width: 0;
`;

export const TopCustomerAvgOrder = styled.div`
  font-size: 14px;
  text-align: right;
  .bold {
    font-weight: 700;
  }
`;

export const ViewAllRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #fff;
  border-radius: 12px;
  padding: 23px 20px;
  margin-top: 16px;
  font-size: 14px;
  font-weight: 700;
  color: #2f3d48;

  button.ButtonSmallXs {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 150px;
    height: 28px;
    padding: 0;
    font-size: 13px;
    line-height: 1;
    white-space: nowrap;
    @media (max-width: 900px) {
      width: auto;
      min-width: 110px;
      padding: 0 16px;
      height: 26px;
      font-size: 12px;
    }
  }
`;

export const ViewAllRowLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  svg,
  img {
    width: 28px;
    height: 28px;
    flex: 0 0 auto;
  }
  &.darkIcon svg path {
    fill: #2f3d48;
  }
`;
